import { DateInput } from '@components/DateInput'
import { DateFieldProps } from './interface'

export function DateField({
  className,
  label,
  error,
  showErrorMessage,
  ...props
}: DateFieldProps) {
  return (
    <div className={className} id={props.name}>
      {!!label && (
        <div className='font-light text-[12px] mb-[4px] dark:text-secondary-1'>
          {label}
        </div>
      )}
      <DateInput {...props} isError={!!error} />
      {showErrorMessage && !!error && (
        <div className='mt-[10px]'>
          <div className='text-[12px] text-red-3'>{error}</div>
        </div>
      )}
    </div>
  )
}
